import { render, staticRenderFns } from "./BlwSections.vue?vue&type=template&id=1463e106&"
import script from "./BlwSections.vue?vue&type=script&lang=js&"
export * from "./BlwSections.vue?vue&type=script&lang=js&"
import style0 from "./BlwSections.vue?vue&type=style&index=0&id=1463e106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports